import { render } from "./_id.vue?vue&type=template&id=6f74d9dd"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"

import "./_id.vue?vue&type=style&index=0&id=6f74d9dd&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__